//员工个人养老金扣除

import { $http, buildHeaders } from "./index";

//获取列表
export const personalpension_list = (params) => {
  return $http.get("/admin/PersonalPension/index", { params });
};

//删除
export const personalpension_del = (data) => {
  return $http.post("/admin/PersonalPension/del", data, {
    headers: buildHeaders(3),
  });
};

//从税局更新数据
export const personalpension_pull = (data) => {
  return $http.post("/admin/PersonalPension/pull", data, {
    headers: buildHeaders(3),
  });
};

//获取操作记录
export const personalpension_log = (params) => {
  return $http.get("/admin/PersonalPension/log", {
    params,
    headers: buildHeaders(3),
  });
};
